// A reply that follows a fired follow-up reminder answers it. Kept out of use-reminders.ts
// so the outbox (which runs long after any component) imports only this.

import type { QueryClient } from '@tanstack/react-query';
import { supabase } from './supabase';

/** Mark my fired, still-open reminders on this ticket done. Rows are mine by row-level
 *  security, so no user id is needed. Best effort: never throws. */
export function markFiredRemindersDone(qc: QueryClient, ticketId: string): void {
  void Promise.resolve(
    supabase
      .from('ticket_reminders')
      .update({ done_at: new Date().toISOString() })
      .eq('ticket_id', ticketId)
      .not('fired_at', 'is', null)
      .is('done_at', null)
      .is('cancelled_at', null),
  )
    .then(() => {
      qc.invalidateQueries({ queryKey: ['my-reminders'] });
      qc.invalidateQueries({ queryKey: ['reminder-tickets'] });
    })
    .catch(() => {});
}
